import React, { useEffect } from 'react';

const TenorGif = ({ postId, shareMethod, aspectRatio, width }) => {
  useEffect(() => {
    // This script is required by Tenor to render the GIF
    const script = document.createElement('script');
    script.src = 'https://tenor.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up the script when the component unmounts
      const existingScript = document.querySelector('script[src="https://tenor.com/embed.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div
      className="tenor-gif-embed"
      data-postid={postId}
      data-share-method={shareMethod}
      data-aspect-ratio={aspectRatio}
      data-width={width}
    >
      <a href={`https://tenor.com/view/gif-${postId}`}>Tenor GIF</a>
    </div>
  );
};

export default TenorGif; 